import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class HasRoleGuard implements CanActivate {
  constructor(private authService: AuthService) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    // const isAuthorized = this.authService.user?.roles.includes(route.data.role);
    let isAuthorized;
    // if (this.authService.user?.role == "Admin") {
    //   isAuthorized = true
    // }
    // if (!isAuthorized) {
    //   // redirect
    //   // display a message
    //   window.alert('you are not authorized');
    // }

    return isAuthorized || false;
  }
}
